.Badge {
  align-items: center;
  background-color: var(--rv-bg-app-subtle);
  border-radius: var(--rv-radius-sm);
  color: var(--rv-fg-2);
  display: inline-flex;
  font-family: var(--rv-font-sans);
  font-size: var(--rv-text-xs);
  font-weight: var(--rv-w-medium);
  gap: var(--rv-space-1);
  height: var(--rv-space-5);
  letter-spacing: var(--rv-track-wide);
  padding: 0 var(--rv-space-2);
  white-space: nowrap;
}

/* No background — only the (colored) dot and a neutral label */
.Badge.ghost {
  background-color: transparent;
  color: var(--rv-fg-2);
  padding-left: 0;
  padding-right: 0;
}

.Dot {
  background: currentcolor;
  border-radius: 50%;
  flex-shrink: 0;
  height: 5px;
  width: 5px;
}

/* Default / secondary — neutral fill */
.Badge.secondary {
  background-color: var(--rv-bg-app-subtle);
  color: var(--rv-fg-2);
}

/* Outline — transparent with neutral border */
.Badge.outline {
  background-color: transparent;
  border: 1px solid var(--rv-border);
  color: var(--rv-fg-2);
}

/* Destructive / danger */
.Badge.destructive {
  background-color: var(--rv-danger-bg);
  color: var(--rv-danger-ink);
}

/* Indicator color variants (legacy named) — map to badge bg/ink tokens */
.Badge.blue {
  background-color: var(--background-badge-blue);
  color: var(--content-badge-label-blue);

  &.outline {
    background-color: transparent;
    border: 1px solid var(--rv-info);
    color: var(--content-badge-label-blue);
  }

  &.ghost {
    background-color: transparent;
    color: var(--rv-fg-2);

    & .Dot {
      background: var(--rv-info);
    }
  }
}

.Badge.green {
  background-color: var(--rv-success-bg);
  color: var(--rv-success-ink);

  &.outline {
    background-color: transparent;
    border: 1px solid var(--border-foundation-border-success);
    color: var(--rv-success-ink);
  }

  &.ghost {
    background-color: transparent;
    color: var(--rv-fg-2);

    & .Dot {
      background: var(--rv-success);
    }
  }
}

.Badge.orange {
  background-color: var(--rv-warning-bg);
  color: var(--rv-warning-ink);

  &.outline {
    background-color: transparent;
    border: 1px solid var(--rv-warning);
    color: var(--rv-warning-ink);
  }

  &.ghost {
    background-color: transparent;
    color: var(--rv-fg-2);

    & .Dot {
      background: var(--rv-warning);
    }
  }
}

/* cyan slot is now the mint accent badge */
.Badge.cyan {
  background-color: var(--mint-alpha-12);
  color: var(--mint-700);

  &.outline {
    background-color: transparent;
    border: 1px solid var(--rv-accent);
    color: var(--mint-700);
  }

  &.ghost {
    background-color: transparent;
    color: var(--rv-fg-2);

    & .Dot {
      background: var(--rv-accent);
    }
  }
}

.Badge.red {
  background-color: var(--rv-danger-bg);
  color: var(--rv-danger-ink);

  &.outline {
    background-color: transparent;
    border: 1px solid var(--rv-danger);
    color: var(--rv-danger-ink);
  }

  &.ghost {
    background-color: transparent;
    color: var(--rv-fg-2);

    & .Dot {
      background: var(--rv-danger);
    }
  }
}

.Badge.small {
  border-radius: var(--rv-radius-xs);
  font-size: var(--rv-text-xxs);
  height: auto;
  padding: var(--space-xxs) var(--rv-space-1);
}
